import { useState } from 'react';
import { mockFormData } from './mockApi';
import './DevTools.css';

const DevTools = ({ onFillForm, onClearForm, currentStep, onJumpToStep }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (import.meta.env.PROD) {
    return null; // Don't show in production
  }

  return (
    <div className={`dev-tools ${isOpen ? 'open' : 'closed'}`}>
      <button 
        className="dev-tools-toggle"
        onClick={() => setIsOpen(!isOpen)}
        title="Developer Tools"
      >
        {isOpen ? '✕' : '🛠️'}
      </button>
      
      {isOpen && (
        <div className="dev-tools-panel">
          <h3>🧪 Developer Tools</h3>
          
          <div className="dev-tools-section">
            <h4>Quick Actions</h4>
            <button onClick={onFillForm} className="dev-btn">
              📋 Fill with Test Data
            </button>
            <button onClick={onClearForm} className="dev-btn">
              🗑️ Clear All Fields
            </button>
          </div>

          <div className="dev-tools-section">
            <h4>Jump to Step</h4>
            <div className="dev-step-buttons">
              {[1, 2, 3, 4, 5].map(step => (
                <button
                  key={step}
                  onClick={() => onJumpToStep(step)}
                  className={`dev-step-btn ${currentStep === step ? 'active' : ''}`}
                >
                  {step}
                </button>
              ))}
            </div>
          </div>

          <div className="dev-tools-section">
            <h4>Current Data</h4>
            <p className="dev-info">Check browser console (F12) for form data</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DevTools;
